import React, { useState, useEffect } from 'react';
import { Box, Container, Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import WbButton from '../../../components/common/WbButton';
import WbLoader from '../../../components/common/WbLoader';
import KioskLayout from '../../../components/kiosk/KioskLayout';
import { useKiosk } from '../../../contexts/KioskContext';
import kioskApi from '../../../services/api/kiosk/kioskApi';
import paths from '../../../routes/paths';
import '../KioskStyles.scss';
import { iconStartSurvey, iconLogout } from '../../../components/assets/images';

export default function ParentThankYou() {
  const { schoolSlug } = useParams();
  const { school, loading: schoolLoading } = useKiosk();
  const navigate = useNavigate();
  const [remainingSurveys, setRemainingSurveys] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkRemainingSurveys = async () => {
      try {
        const verifiedParent = JSON.parse(localStorage.getItem('kiosk-verified-parent') || '{}');
        if (verifiedParent.parentId && school?.schoolId) {
          const data = await kioskApi.getParentSurveys(school.schoolId, verifiedParent.parentId);
          setRemainingSurveys(data || []);
        }
      } catch (err) {
        console.error('Error checking remaining surveys:', err);
      } finally {
        setLoading(false);
      }
    };

    if (!schoolLoading && school) {
      checkRemainingSurveys();
    }
  }, [schoolSlug, schoolLoading, school]);

  const handleNextSurvey = () => {
    if (remainingSurveys.length > 0) {
      navigate(paths.kioskParentSurveys.replace(':schoolSlug', schoolSlug));
    }
  };

  const handleLogOut = () => {
    localStorage.removeItem('kiosk-verified-parent');
    navigate(paths.kioskParentWelcome.replace(':schoolSlug', schoolSlug));
  };

  if (schoolLoading || loading) {
    return (
      <KioskLayout>
        <WbLoader />
      </KioskLayout>
    );
  }

  const hasMoreSurveys = remainingSurveys.length > 0;

  return (
    <KioskLayout>
      <Container maxWidth="md">        
        <Box className="kiosk-thank-you">            
          <div className="kiosk-congrat">
            Congratulations!
          </div>
          <div className="kiosk-survey-complete">
            You've completed the survey 🎉
          </div>

          {/* {hasMoreSurveys && (
            <div className='kiosk-logout'>
              You have more surveys available. Start the next survey or log out.
            </div>
          )}

          {!hasMoreSurveys && (
            <div className='kiosk-logout'>
              You may now logout. The next survey can begin when ready.
            </div>
          )} */}

          <Stack direction="row" spacing={1} justifyContent="center" mt={4}>
            <div>
              {hasMoreSurveys && (
                <WbButton
                  CustomButtonText="Start Next Survey"
                  onClick={handleNextSurvey}
                  className="kiosk-button-large"
                  startIcon={<img src={iconStartSurvey} alt="Start Next Survey"/>}                
                />
              )}
            </div>
            <div>
              <WbButton
                CustomButtonText="Log Out"
                onClick={handleLogOut}
                className="kiosk-button-logout"
                startIcon={<img src={iconLogout} alt="Log Out" />}
              />
            </div>
          </Stack>
        </Box>
      </Container>
    </KioskLayout>
  );
}
